export const NAV_PROJECT_ASSESS = 'projectAssess', NAV_PROJECT_MANAGE = 'projectManage', NAV_DATA_STATISTICS = 'dataStatistics'

export const NAV_PROJECT_ASSESS_VIEW = {
    label: '绩效评估',
    key: NAV_PROJECT_ASSESS,
    defaultRoute: '/perf'
}

export const NAV_PROJECT_MANAGE_VIEW = {
    label: '项目管理',
    key: NAV_PROJECT_MANAGE,
    defaultRoute: '/perf/manage'
}

export const NAV_DATA_STATISTICS_VIEW = {
    label: '数据统计',
    key: NAV_DATA_STATISTICS,
    defaultRoute: '/statistics/view/index'
}